import { useResidenceList } from '~src/hooks/services/useResidence';

import { useCreateOfferState } from '../state/createOfferState';

export const useCustomerResidenceList = () => {
  const { customer } = useCreateOfferState();

  return useResidenceList(customer?.id);
};
